import { render, staticRenderFns } from "./cateGoods.vue?vue&type=template&id=382bd065&"
import script from "./cateGoods.vue?vue&type=script&lang=js&"
export * from "./cateGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports